import type React from 'react'
import './PackageCard.scss'
import { Tag } from '@/components/Tag'

const PLACEHOLDER_IMAGE_SRC =
  'https://cdn.shopify.com/s/files/1/0192/0076/files/meal-program-subscription.png?v=1650377978'

type PackageCardProps = {
  imageSrc?: string
  isActive?: boolean
  notice: string
  title: string
  body?: any
  info: any
  extraInfo?: any
  buttons: React.ReactNode
  homepage?: boolean
}

export const PackageCard: React.FC<PackageCardProps> = ({
  imageSrc,
  isActive = true,
  notice,
  title,
  body,
  info,
  extraInfo,
  buttons,
  homepage,
}) => {
  const classes = `c-package-card ${isActive ? 'is-active' : 'is-inactive'} ${
    homepage ? 'is-homepage' : 'is-account-page'
  }`

  return (
    <div className={classes}>
      <div className="c-package-card__wrapper">
        <div className="c-package-card__overview">
          <img
            src={imageSrc || PLACEHOLDER_IMAGE_SRC}
            alt="Package"
            className="c-package-card__image"
            loading="lazy"
          />
          <div className="c-package-card__overview-content">
            <h2 className="c-package-card__title type-h6">{title}</h2>
            <p className="c-package-card__info type-label">{info}</p>
            <div className="c-package-card__body type-body">{body}</div>
            <Tag type="inline" text={notice} />
          </div>
        </div>
        <div className="c-package-card__actions">
          {extraInfo && (
            <div className="c-package-card__extra-info type-body">
              {extraInfo}
            </div>
          )}
          <div className="c-package-card__buttons">{buttons}</div>
        </div>
      </div>
    </div>
  )
}
